/*
* ON_YOU - ключ на мне.
UNAVAILABLE - ключ занят.
AWAITS - ключ передан мне, но я еще не подтвердил получение. Должна быть кнопка "Принять ключ" и при нажатии выходит не QR а передается на бэк принятие ключа
AVAILABLE - получить ключ
* */
import { ERROR_COLORS, PRIMARY_COLORS, SUCCESS_COLORS } from 'asterX-UI'

export const ON_YOU = 'ON_YOU'
export const UNAVAILABLE = 'UNAVAILABLE'
export const AWAITS = 'AWAITS'
export const AVAILABLE = 'AVAILABLE'

export const KEY_STATUSES = {
  [ON_YOU]: 'ключ на мне',
  [UNAVAILABLE]: 'ключ занят',
  [AWAITS]: 'Передаеться мне',
  [AVAILABLE]: 'Можно получить'
}

export const KEY_STATUSES_COLORS = {
  [ON_YOU]: {
    color: SUCCESS_COLORS[700],
    backgroundColor: SUCCESS_COLORS[50]
  },
  [UNAVAILABLE]: {
    color: ERROR_COLORS[700],
    backgroundColor: ERROR_COLORS[50]
  },
  [AWAITS]: {
    color: PRIMARY_COLORS[700],
    backgroundColor: PRIMARY_COLORS[50]
  },
  [AVAILABLE]: {
    color: PRIMARY_COLORS[700],
    backgroundColor: PRIMARY_COLORS[50]
  }
}

export const ROP_CAR_CODES = {
  manager: '10',
  waiting_consultation: '20',
  consultation: '30',
  after_consultation: '40',
  demonstration: '50',
  car_selection: '60', // Выбор авто
  car_selection_2: '70', //  Подбор авто
  closing_approval: '80',
  discount_approval: '90',
  SERVICE_COMPLETED: '100'
}
